import React from "react";
import LoginPage from "../components/LoginPage.tsx";
import { useAppDispatch } from '../redux/hook.ts';
import { setSession } from "../redux/sessionSlice.ts";
import { setUser } from "../redux/userSlice.ts";
import { setFSession, setFUser } from "../redux/facilitatorSessionSlice.ts";
import { useToast } from '../components/base_components/ToastContext.tsx';
import { useNavigate } from "react-router-dom";
import FacilitatorService from "../api_handlers/services/FacilitatorService.ts";
import SessionService from "../api_handlers/services/SessionService.ts";
import IInitializeSessionVM from '../api_handlers/view_modals/IInitializeSessionVM.ts';
import IFacilitatorLogin from "../api_handlers/view_modals/IFacilitatorLogin.ts";
import votingService from "../api_handlers/services/VotingService.ts";

const FacilitatorLogin = () => {
    const dispatch = useAppDispatch();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const fetchVotingStatus = async (id) => {
        try {
            const res = await votingService.isVotingStarted(id);
            return res.data;
        } catch (err) {
            console.error("Error fetching voting status:", err);
        }
    };

    // Function to handle login
    const handleLogin = async (_data: any) => {
        const isFacilitator = _data.isFacilitator;

        if (isFacilitator) {
            // Handle facilitator login
            const vm: IFacilitatorLogin = {
                email: _data.email,
                name: _data.name,
                gaminarCode: _data.gaminarCode,
            };

            try {
                const res = await FacilitatorService.login(vm);
                dispatch(setFSession({
                    gaminarCode: _data.gaminarCode,
                    sessionId: res.data.sessionId,
                    userName: _data.name
                }));
                dispatch(setFUser({ email: _data.email, userName: _data.name }));
                navigate("/FacilitatorPage");
            } catch (err) {
                console.error("Facilitator login error:", err);
            }
        } else {
            // Handle scoring session login
            const vm: IInitializeSessionVM = {
                userEmail: _data.email,
                userName: _data.name,
                teamId: _data.teams,
                gaminarCode: _data.gaminarCode,
            };

            try {
                const data = await SessionService.initializeVotingSession(vm);
                const { sessionId, teamId, userId } = data.data;
                dispatch(setSession({
                    sessionId: sessionId,
                    teamId: teamId,
                    userId: userId,
                    gaminarCode: _data.gaminarCode
                }));
                const isVotingStarted = await fetchVotingStatus(sessionId);
                dispatch(setUser({ email: _data.email, userName: _data.name }));
                dispatch(setFUser({email: _data.facilatatorEmail, userName: ''}))
                if(isVotingStarted) {
                    navigate('/LandingPage');
                }else {
                    await SessionService.initializeScoringSession(vm);
                    navigate('/scoring');
                }
            } catch (err) {
                if (err.status === 500 && err.response?.data) {
                    showToast(err.response.data, "error");
                }
            }
        }
    };

    return (
        <LoginPage
            onLoginClickCallback={handleLogin}
            headerText="Login"
        />
    );
}

export default FacilitatorLogin;